import {reloadEventListeners} from './RequestPasswordSubscriber';

const closeButton = document.querySelector('#login-modal .js-modal-close');

const formWrapper = document.querySelector('.js-form-wrapper');
const formWrapperLogin = document.querySelector('.js-login-form-wrapper');

function loginFormContentReset() {
    if (formWrapper) {
        const initialContent = formWrapperLogin.outerHTML;
        const modalBackdrop = document.querySelector('.modal__backdrop');

        // Click on close button
        closeButton.addEventListener('click', () => {
            const formWrapperReset = document.querySelector('.js-request-password-form-wrapper');

            if (formWrapperReset) {
                setTimeout(() => { // timeout so it doesn't flash the initial content when closing modal
                    formWrapperReset.outerHTML = initialContent;

                    reloadEventListeners();
                }, 500);
            }
        });

        // Click on backdrop
        modalBackdrop.addEventListener('click', () => {
            const formWrapperReset = document.querySelector('.js-request-password-form-wrapper');

            if (formWrapperReset) {
                setTimeout(() => { // timeout so it doesn't flash the initial content when closing modal
                    formWrapperReset.outerHTML = initialContent;

                    reloadEventListeners();
                }, 500);
            }
        });
    }
}

export default loginFormContentReset;



// WEBPACK FOOTER //
// ./src/Will/WebsiteBundle/Resources/ui/js/LoginFormContentReset.js